import styled, {css} from 'styled-components';

import {TextBig} from '~components/atoms/Text';

import {NoPlotsFoundProps} from '.';

export const ErrorContainer = styled.div<NoPlotsFoundProps>`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
    ${({color}) =>
        color === 'white'
            ? css`
                  color: #ffffff;
                  text-shadow: 0px 1px 3px rgba(0, 0, 0, 0.4);
                  button {
                      filter: drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.4));
                  }
              `
            : css`
                  color: #000000;
                  svg {
                      & > * {
                          filter: none;
                      }
                  }
              `}
`;

export const ErrorMessage = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const ErrorText = styled(TextBig)`
    margin: 12px 0 21px 0;
`;
